module.exports = __webpack_public_path__ + "img/flfw_11.2ed99de8.png";